import React from 'react';

export const HtmlContent = ({content, className}) => {
    return (
        <div className={className} dangerouslySetInnerHTML={{
            __html: content
        }}/>
    );
}
